'use client';
import { memo } from 'react';

import { useLang } from '@/hooks';

export const Title = memo(({ title }: { title: string }) => {
	const { t } = useLang();
	return <p className="my-8 text-3xl font-bold text-blue-2">{t(title)}</p>;
});
